export const allDevicesCheckRegisterCheckbox = () => {
    $("input[type='password']").on("keyup", function() {
        var passwords = $("#create-password").val() + $("#verify-choose-password").val();
        (passwords.length > 0) ? $('#reg_checkbox').prop('checked', 'checked') : $('#reg_checkbox').prop('checked', '');
    });
};
